<div class="scroll-container">
    <div class="row">
        <ng-content></ng-content>
    </div>
    <div class="mt-md-3">
        <pace-forms2-renderer></pace-forms2-renderer>
    </div>
</div>
<pace-forms2-navbar></pace-forms2-navbar>
